import {shadow} from '@packages/utilities/inline-style-utils';
import {
  isTransparent,
  isPartiallyTransparent,
  lighten,
} from '@packages/systems/core/utils/ColorUtils';

import {styledDiv, styled} from '@packages/utilities/styled';
import {
  SwatchNib as CornerNibIcon,
  DropletSmall as DropletIcon,
} from '@packages/systems/ui/icons';
import {TransparentCheckerboardDark as DarkCheckerboardIcon} from '@packages/systems/ui/icons/style-panel';
import {emptyObject} from '@packages/utilities/fp/utils';

const {width: nibLength} = CornerNibIcon({}).props;

const HIGHLIGHT_AMOUNT = 8;
const highlight = lighten(HIGHLIGHT_AMOUNT);

const StyledDarkCheckerboardIcon = styled(DarkCheckerboardIcon)(() => ({
  position: 'relative',
  top: -1,
  left: -1,
  color: 'black',
}));

const nibStyle = () => ({
  position: 'absolute',
  color: 'white',
  right: 0,
  bottom: 0,
  width: nibLength,
  height: nibLength,
});

// @ts-expect-error - TS7031 - Binding element 'colors' implicitly has an 'any' type.
const dropletStyle = ({theme: {colors}}) => ({
  color: colors.foregroundDim,
});

const styleSwatch = ({
  // @ts-expect-error - TS7031 - Binding element 'control' implicitly has an 'any' type. | TS7031 - Binding element 'colors' implicitly has an 'any' type.
  theme: {control, colors},
  // @ts-expect-error - TS7031 - Binding element 'color' implicitly has an 'any' type.
  style: {background: color, ...rest},
}) => ({
  position: 'relative',
  boxSizing: 'border-box',
  overflow: 'hidden',
  borderWidth: control.borderWidth,
  borderStyle: 'solid',
  borderColor: colors.borderDeep,
  background:
    !isPartiallyTransparent(color) && !isTransparent(color)
      ? color
      : highlight(color),
  ...rest,
});

const variations = {
  // @ts-expect-error - TS7031 - Binding element 'focusColors' implicitly has an 'any' type.
  keyboardFocus: ({theme: {focusColors}}) => ({
    boxShadow: focusColors.outline,
    outline: 0,
  }),
  // @ts-expect-error - TS7031 - Binding element 'colors' implicitly has an 'any' type.
  selected: ({theme: {colors}}) => ({
    boxShadow: shadow(0, 0, 0, 1, colors.foregroundVivid),
  }),
  // @ts-expect-error - TS7031 - Binding element 'colors' implicitly has an 'any' type. | TS7031 - Binding element 'color' implicitly has an 'any' type. | TS7031 - Binding element 'noShadow' implicitly has an 'any' type.
  hover: ({theme: {colors}, color, noShadow}) => {
    return noShadow
      ? {
          background:
            !isPartiallyTransparent(color) && !isTransparent(color)
              ? highlight(color || colors.control)
              : '',
        }
      : {
          boxShadow: shadow(0, 0, 0, 1, colors.foreground),
        };
  },
  disabled: {
    opacity: 0.2,
    boxShadow: 'none',
  },
  // @ts-expect-error - TS7031 - Binding element 'control' implicitly has an 'any' type.
  right: ({theme: {control}}) => ({
    borderTopRightRadius: control.borderRadius,
    borderBottomRightRadius: control.borderRadius,
  }),
  // @ts-expect-error - TS7031 - Binding element 'control' implicitly has an 'any' type.
  left: ({theme: {control}}) => ({
    borderTopLeftRadius: control.borderRadius,
    borderBottomLeftRadius: control.borderRadius,
  }),
} as const;

// @ts-expect-error - TS2345 - Argument of type '{ readonly keyboardFocus: ({ theme: { focusColors } }: { theme: { focusColors: any; }; }) => { boxShadow: any; outline: number; }; readonly selected: ({ theme: { colors } }: { theme: { colors: any; }; }) => { boxShadow: string; }; readonly hover: ({ theme: { colors }, color, noShadow }: { theme: { ...; }; color: any...' is not assignable to parameter of type 'VariantMap<{ theme: { control: any; colors: any; }; style: { [x: string]: any; background: any; }; }>'.
export const Swatch = styledDiv(styleSwatch, variations);
export const Nib = styled(CornerNibIcon)(nibStyle);
export const Droplet = styled(DropletIcon)(dropletStyle);
export const DarkTransparent = styled(StyledDarkCheckerboardIcon)(emptyObject);
